import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setCreateGroup = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_GROUPS_CASHIERS
            });
            dispatch(Action.SetGroups({
                group: ''
            }));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setCreateGroup as SetCreateGroup
}